/**
 * @generated SignedSource<<b27ee20d1a92073958194efa459b805d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpSharingIcons_nftItem$data = {
  readonly creatorAddress: {
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
  } | null;
  readonly metadata: {
    readonly description?: string | null;
    readonly media?: {
      readonly webUrl: string | null;
    } | null;
    readonly name?: string | null;
  } | null;
  readonly pdpUrl: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_nftItem">;
  readonly " $fragmentType": "NftPdpSharingIcons_nftItem";
};
export type NftPdpSharingIcons_nftItem$key = {
  readonly " $data"?: NftPdpSharingIcons_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpSharingIcons_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpSharingIcons_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeartPill_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "3ca65e29f5def2a6df87d676c6dc7380";

export default node;
